import { vaultFetch } from './vault-api-core.ts'

export type VaultEnvGrantMode = 'run' | 'restricted'
export type VaultItemGrantMode = 'run' | 'restricted' | 'deny'

export interface VaultEnvGrantRow {
  id: string
  principalId: string
  nodeId: string
  environment: string
  mode: VaultEnvGrantMode
  recursive: boolean
  [key: string]: unknown
}

export interface VaultItemGrantRow {
  id: string
  principalId: string
  itemId: string | null
  nodeId: string | null
  keyGlob: string
  mode: VaultItemGrantMode
  [key: string]: unknown
}

export interface VaultGrantsOut {
  env: VaultEnvGrantRow[]
  item: VaultItemGrantRow[]
}

// ── grants ──────────────────────────────────────────────────────────────
export function listGrants(
  rootId: string,
  principalId: string,
): Promise<VaultGrantsOut> {
  return vaultFetch<VaultGrantsOut>(
    `/vault/admin/${rootId}/principals/${principalId}/grants`,
  )
}

export function putEnvGrant(
  rootId: string,
  principalId: string,
  body: {
    nodeId: string
    environment: string
    mode: VaultEnvGrantMode
    recursive: boolean
  },
): Promise<VaultEnvGrantRow> {
  return vaultFetch<VaultEnvGrantRow>(
    `/vault/admin/${rootId}/principals/${principalId}/grants/env`,
    { method: 'PUT', body: JSON.stringify(body) },
  )
}

export function deleteEnvGrant(
  rootId: string,
  principalId: string,
  grantId: string,
): Promise<void> {
  return vaultFetch<undefined>(
    `/vault/admin/${rootId}/principals/${principalId}/grants/env/${grantId}`,
    { method: 'DELETE' },
  )
}

export function addItemGrant(
  rootId: string,
  principalId: string,
  body: {
    itemId?: string
    nodeId?: string
    keyGlob?: string
    mode: VaultItemGrantMode
  },
): Promise<VaultItemGrantRow> {
  return vaultFetch<VaultItemGrantRow>(
    `/vault/admin/${rootId}/principals/${principalId}/grants/item`,
    { method: 'POST', body: JSON.stringify(body) },
  )
}

export function deleteItemGrant(
  rootId: string,
  principalId: string,
  grantId: string,
): Promise<void> {
  return vaultFetch<undefined>(
    `/vault/admin/${rootId}/principals/${principalId}/grants/item/${grantId}`,
    { method: 'DELETE' },
  )
}
